/* import __COLOCATED_TEMPLATE__ from './row.hbs'; */
/**
Row component yielded by `sq-card/attributes-table`, not intended for standalone use.
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'tr',
  classNames: ['card__attributes-table__row']
});